import gql from 'graphql-tag';
import { uploadImage } from './uploadImage';

export const updatePlotMutation = gql`
  mutation updatePlot(
    $id: ID!
    $name: String!
    $status: String!
    $evidenceCode1: String!
    $evidenceCode2: String!
    $evidenceCode3: String
    $evidenceCode4: String
    $evidenceCode5: String
    $evidenceCode6: String
    $evidenceCode7: String
    $evidenceCode8: String
    $evidenceCode9: String
    $evidenceCode10: String
    $evidenceUnlock1: String
    $evidenceUnlock2: String
    $evidenceUnlock3: String
    $evidenceUnlock4: String
    $evidenceUnlock5: String
    $evidenceUnlock6: String
    $evidenceUnlock7: String
    $evidenceUnlock8: String
    $evidenceUnlock9: String
    $evidenceUnlock10: String
    $numberOfEvidence: Int!
    $suspectsCode: String!
    $discountCode: String!
    $dressCode: String
    $maxActors: Int!
    $imageKey: String!
    $description: String!
  ) {
    data: updatePlot(
      id: $id
      name: $name
      status: $status
      evidenceCode1: $evidenceCode1
      evidenceCode2: $evidenceCode2
      evidenceCode3: $evidenceCode3
      evidenceCode4: $evidenceCode4
      evidenceCode5: $evidenceCode5
      evidenceCode6: $evidenceCode6
      evidenceCode7: $evidenceCode7
      evidenceCode8: $evidenceCode8
      evidenceCode9: $evidenceCode9
      evidenceCode10: $evidenceCode10
      evidenceUnlock1: $evidenceUnlock1
      evidenceUnlock2: $evidenceUnlock2
      evidenceUnlock3: $evidenceUnlock3
      evidenceUnlock4: $evidenceUnlock4
      evidenceUnlock5: $evidenceUnlock5
      evidenceUnlock6: $evidenceUnlock6
      evidenceUnlock7: $evidenceUnlock7
      evidenceUnlock8: $evidenceUnlock8
      evidenceUnlock9: $evidenceUnlock9
      evidenceUnlock10: $evidenceUnlock10
      numberOfEvidence: $numberOfEvidence
      suspectsCode: $suspectsCode
      discountCode: $discountCode
      dressCode: $dressCode
      maxActors: $maxActors
      imageKey: $imageKey
      description: $description
    ) {
      id
      name
      status
      evidenceCode1
      evidenceCode2
      evidenceCode3
      evidenceCode4
      evidenceCode5
      evidenceCode6
      evidenceCode7
      evidenceCode8
      evidenceCode9
      evidenceCode10
      evidenceUnlock1
      evidenceUnlock2
      evidenceUnlock3
      evidenceUnlock4
      evidenceUnlock5
      evidenceUnlock6
      evidenceUnlock7
      evidenceUnlock8
      evidenceUnlock9
      evidenceUnlock10
      numberOfEvidence
      suspectsCode
      discountCode
      maxActors
      dressCode
      image {
        url
        __typename
      }
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const updatePlot = async ({ client, params }) => {
  // ImageKey already present
  if (params.data.image.rawFile) {
    params.data.imageKey = await uploadImage(client, params);
  } else {
    params.data.imageKey = params.data.image.url;
  }

  const result = await client.mutate({
    mutation: updatePlotMutation,
    variables: {
      ...params.data,
    },
  });

  return result.data;
};
